<template lang="html">
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols" :for="field.id"> {{ field.label }} {{
                field.required ? '*' : ''
            }} </label>
        <div v-if="fieldData.type === 'Dropdown'" :class="'col-' + fieldCols">
            <select :disabled="field.locked" :required="field.required" :value="defaultValue.key" class="form-select"
                    @input="changeSelection($event.target.value)">
                <option v-if="field.placeholder" disabled="disabled" selected value="">{{ field.placeholder }}</option>
                <option v-if="!field.placeholder" value=""></option>
                <option v-for="item in fieldData.items" :value="item.key">{{ item.value }}</option>
            </select>
        </div>
        <div v-else :class="'col-sm-' + fieldCols">
            <div v-for="item in fieldData.items" class="form-check">
                <input :id="item.key"
                       :checked="item.key === defaultValue.key"
                       :disabled="field.locked"
                       :required="field.required"
                       class="form-check-input"
                       name="field.id"
                       type="radio"
                       @input="changeSelection(item.key)">
                <label :for="item.key" class="form-check-label">{{ item.value }}</label>
            </div>
        </div>
    </div>
</template>

<script lang="js">

export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            data: {
                items: [],
                type: 'Dropdown'
            },
        }
    },
    computed: {
        fieldData() {
            let parsedFieldData = {
                type: 'Dropdown',
                items: []
            }
            if (this.field.data !== '') {
                parsedFieldData = JSON.parse(this.field.data);
            }
            return parsedFieldData;
        },
        defaultValue() {
            let returnValue = {
                key: '',
                value: ''
            };
            if (this.field.value !== '') {
                returnValue = JSON.parse(this.field.value);
            }

            return returnValue;
        }
    },
    mounted() {
        let returnValue = [];
        if (this.field.data !== '') {
            let object = JSON.parse(this.field.data);
            this.data.type = object.type;
            for (let i = 0; i < object.items.length; i++) {
                let item = object.items[i];
                item.checked = this.field.value.indexOf(item.key) > -1;
                returnValue.push(item);
            }
        }
        this.data.items = returnValue;
    },
    methods: {
        changeSelection(key) {
            let item = this.fieldData.items.find(x => x.key === key);
            let newValue = {
                key: item.key,
                value: item.value
            };
            this.$emit('update:modelValue', {value: JSON.stringify(newValue)});
        }
    }
}
</script>